// extracted by mini-css-extract-plugin
export default {"errorMessage":"MySelect_errorMessage__91q50","select":"MySelect_select__l+VmA"};